import script from "./PrepareMailList.vue?vue&type=script&setup=true&lang=js"
export * from "./PrepareMailList.vue?vue&type=script&setup=true&lang=js"

import "./PrepareMailList.vue?vue&type=style&index=0&id=2b662d8c&lang=scss"

const __exports__ = script;

export default __exports__